import styled from "styled-components";

export const FestivalEventBottomWrapper = styled.div`
  width: 100%;
  height: 98px;
  background: #ffffff;
  box-shadow: 0px 0px 12px 0px #00000040;
  position: fixed;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0 16px;
`;

export const FestivalEventBottomState = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 10px;
  text-align: center;

  > img {
    width: 31px;
    height: 31px;
  }
`;

export const FestivalEventBottomButton = styled.div<{
  isOpen: boolean;
  isReservation: boolean;
}>`
  flex: 1;
  height: 48px;
  border-radius: 8px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  line-height: 48px;
  text-align: center;
  background: ${(p) =>
    p.isReservation
      ? "#D91818"
      : p.isOpen
      ? "var(--Purple-300, rgba(100, 54, 231, 1))"
      : "rgba(217, 217, 217, 1)"};
`;
